import { Lock } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { Button } from '@/components/ui/button'

interface UpgradePromptProps {
  feature: string
  description?: string
  inline?: boolean
}

export function UpgradePrompt({ feature, description, inline = false }: UpgradePromptProps) {
  const navigate = useNavigate()

  if (inline) {
    return (
      <div className="flex items-center gap-3 rounded-xl border border-brand-chartreuse/20 bg-brand-chartreuse/5 px-4 py-3">
        <Lock className="h-4 w-4 shrink-0 text-brand-chartreuse" />
        <div className="flex-1">
          <p className="text-sm font-medium text-foreground">
            {feature} requires Pro plan
          </p>
          {description && (
            <p className="text-xs text-foreground/70">{description}</p>
          )}
        </div>
        <Button
          size="sm"
          className="bg-brand-chartreuse text-brand-chartreuse-foreground hover:bg-brand-chartreuse/90"
          onClick={() => navigate('/pricing')}
        >
          Upgrade
        </Button>
      </div>
    )
  }

  return (
    <div className="flex flex-col items-center justify-center gap-4 py-16">
      <div className="rounded-full border border-border bg-muted/50 p-4">
        <Lock className="h-8 w-8 text-muted-foreground/60" />
      </div>
      <div className="text-center">
        <h3 className="text-lg font-semibold text-foreground">{feature} requires Pro</h3>
        <p className="mt-1 text-sm text-foreground/70">
          {description ?? 'Upgrade to Pro to unlock this feature and get unlimited access.'}
        </p>
      </div>
      <Button
        className="bg-brand-chartreuse text-brand-chartreuse-foreground hover:bg-brand-chartreuse/90"
        onClick={() => navigate('/pricing')}
      >
        Upgrade to Pro
      </Button>
    </div>
  )
}
